<script setup lang="ts">
import WizardTabWithSidebar from '../WizardTabWithSidebar.vue'
import { inject } from 'vue'
import AccountPanelPersonalSignatures from '../../account/personal/pages/AccountPanelPersonalSignatures.vue'
import WizardHeader from '../WizardHeader.vue'
import { IdentificationIcon } from '@heroicons/vue/solid'
import WizardStepCount from '../WizardStepCount.vue'
import BaseButtonMuted from '../../base/BaseButtonMuted.vue'
import { getAccountLink } from '../../../utilities/useLinks'
const { navigateToTab } = inject('navigation')
const closeWizard = inject('closeWizard')
function closeAndNavigateToAccount() {
    closeWizard()
    window.location = getAccountLink() + '?menu=Verification'
}
</script>

<template>
    <WizardTabWithSidebar
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <WizardHeader :title="$t('account_settings.kyc_form')" :icon="IdentificationIcon">
                <WizardStepCount></WizardStepCount>
            </WizardHeader>
            <div class="px-4 pt-8 sm:px-6">
                <div class="border-gray-150 rounded-lg border shadow-md">
                    <AccountPanelPersonalSignatures></AccountPanelPersonalSignatures>
                </div>
            </div>
        </template>
        <template #nextButton>
            <BaseButtonMuted class="mx-auto block" size="lg" @click="closeAndNavigateToAccount">{{
                $t('widget.close')
            }}</BaseButtonMuted>
        </template>

        <template #sidebar>
            <div
                class="prose prose-slate leading-normal text-gray-800 prose-p:my-3 prose-ul:mb-3 prose-ul:mt-0 prose-li:mt-1"
                v-html="$t('esac_widget_sidebar.natural_kyc_form')"></div>
        </template>
    </WizardTabWithSidebar>
</template>

<style scoped></style>
